import { render, staticRenderFns } from "./cmsPagesView.vue?vue&type=template&id=3cb59d82&v-if=pageData&"
import script from "./cmsPagesView.vue?vue&type=script&lang=js&"
export * from "./cmsPagesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports